import { Badge, Button, Radio, Tag, Typography } from "antd";
import { Big } from "bigdecimal.js";
import { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom";
import CustomPaymentModal from "./CustomPaymentModal";
import SplitPaymentModal from "./SplitPaymentModal";
import { withNamespaces } from "react-i18next";
import {
  CheckOutlined,
  ClockCircleFilled,
  RightOutlined,
  RollbackOutlined,
  SwapOutlined,
} from "@ant-design/icons";

const { Text } = Typography;
export class OrderPayment extends Component {
  state = {
    customPaymentModallVisible: false,
    splitPaymentModalVisible: false,
  };
  render() {
    const {
      t,
      settings,
      customer,

      orderTotalPrice,
      manuallyAppliedPromotion,
      payments,
      orderPayments,
      editOrder,
      paymentCType,
      paymentComplete,
      paymentType,
      paymentReference,
      setOrderSettingsState,
      config,
      actualOrderTotal,
    } = this.props;

    const { splitPaymentModalVisible, customPaymentModallVisible } = this.state;

    const checkIfCashAndOnlineDisabled =
      !settings.enable_cash_for_pos && !settings.enable_online_payments_for_pos;

    const avaialblePoints =
      customer?.userDetails?.points -
      (manuallyAppliedPromotion?.loyaltyPointsCost || 0);

    const loyaltyPointsNeeded = Math.ceil(
      orderTotalPrice *
        (settings.loyalty_points_to_money_threshold /
          settings.loyalty_points_to_money_conversion_rate),
    );

    const totalPaid = payments
      .reduce((sum, p) => sum.add(p.amount?.toFixed(6)), Big(0))
      .numberValue();
    const amountLeft = Big(actualOrderTotal ?? orderTotalPrice)
      .subtract(totalPaid)
      .numberValue();
    const currency =
      config.language === "arabic"
        ? settings.currency_local
        : settings.currency_english;

    const isReturningPayment =
      editOrder && amountLeft < 0 && orderPayments.length >= 1;

    const paidPayments = payments.filter(
      (p) => p.amount > 0 && p.payment_complete && p.payment_ctype !== "return",
    );
    const unPaidPayments = payments.filter(
      (p) =>
        p.amount > 0 && !p.payment_complete && p.payment_ctype !== "return",
    );
    const returnedPayments = payments.filter(
      (p) => p.payment_ctype == "return" || p.amount < 0,
    );

    const paymentMethodsNames = [
      ...new Set(
        payments
          .filter((p) => p.amount > 0 && p.payment_ctype !== "return")
          .map((p) => p.payment_method),
      ),
    ]
      .map((m) => m.charAt(0).toUpperCase() + m.slice(1))
      .join(" · ");

    const forceSplitPayments =
      (editOrder &&
        (orderPayments.length > 1 ||
          orderPayments.some((p) => p.payment_complete)) &&
        amountLeft !== 0) || //this was orderPayments
      (actualOrderTotal !== null && amountLeft !== 0); // force open if the order has more than one payments objects or there was an error with order total cualculaation
    const hidePayments =
      forceSplitPayments ||
      (editOrder &&
        (orderPayments.length > 1 ||
          orderPayments.filter((p) => p.payment_complete).length >= 1)) || // why did i make this >= before ( i made it so the if there one order pay and the other now to know which one to edit)
      paymentType === "split"; // hide payments if there are more than one payments
    return (
      <>
        {customPaymentModallVisible && (
          <CustomPaymentModal
            visible={customPaymentModallVisible}
            paymentCType={paymentCType}
            paymentReference={paymentReference}
            onClose={(paymentMethod, paymentReference) => {
              if (paymentMethod) {
                setOrderSettingsState({
                  paymentType: "custom",
                  paymentCType: paymentMethod,
                  paymentReference,
                });
              }
              this.setState({ customPaymentModallVisible: false });
            }}
          />
        )}
        {(forceSplitPayments || splitPaymentModalVisible) && (
          <SplitPaymentModal
            visible={forceSplitPayments || splitPaymentModalVisible}
            actualOrderTotal={actualOrderTotal}
            isEditingOrder={Boolean(editOrder)}
            orderTotal={Number(orderTotalPrice)}
            totalPaid={totalPaid}
            isReturningPayment={isReturningPayment}
            payments={payments}
            onResetPayments={() => {
              setOrderSettingsState({
                paymentType: settings.default_payment_method_pos || "cash",
                paymentCType: "",
                paymentReference: "",
                payments: [],
              });
            }}
            onClose={(payments) => {
              if (payments) {
                setOrderSettingsState({
                  paymentType: "split",
                  payments: payments,
                  paymentReference,
                });
              } else if (forceSplitPayments) {
                //incase it was forced open and the user tried to close the split payment modal
                this.props.closePlaceOrderModal();
              }
              this.setState({ splitPaymentModalVisible: false });
            }}
          />
        )}

        <div className="px-2 my-4  text-center">
          <p style={{ fontSize: 15 }}>
            {isReturningPayment ? t("Return Method") : t("Payment Method")}
          </p>
          {isReturningPayment && (
            <p style={{ fontSize: 17, color: "red" }}>
              - {Math.abs(amountLeft).toFixed(settings.currency_decimals)}{" "}
              {currency}
            </p>
          )}

          {editOrder && amountLeft > 0 && (
            <p style={{ fontSize: 17, color: "green" }}>
              + {Math.abs(amountLeft).toFixed(settings.currency_decimals)}{" "}
              {currency}
            </p>
          )}

          {hidePayments && (
            <div
              onClick={() => this.setState({ splitPaymentModalVisible: true })}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                border: "1px solid #d9d9d9",

                padding: "12px 16px",
                cursor: "pointer",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: "50%",
                    background: "#E6F4FF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <SwapOutlined
                    style={{ fontSize: 16, top: 0, color: "#0099cc" }}
                  />
                </div>

                <div>
                  <Text strong style={{ fontSize: 14, display: "block" }}>
                    {t("Manage payments")}
                  </Text>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    {paymentMethodsNames}
                  </Text>
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div
                  style={{
                    display: "flex",
                    gap: 4,
                    flexWrap: "wrap",
                    justifyContent: "flex-end",
                  }}
                >
                  {paidPayments.length > 0 && (
                    <Tag
                      icon={<CheckOutlined />}
                      color="success"
                      style={{ margin: 0, fontSize: 11 }}
                    >
                      {paidPayments.length} {t("paid")}
                    </Tag>
                  )}
                  {unPaidPayments.length > 0 && (
                    <Tag
                      icon={<ClockCircleFilled />}
                      color="error"
                      style={{ margin: 0, fontSize: 11 }}
                    >
                      {unPaidPayments.length} {t("unpaid")}
                    </Tag>
                  )}
                  {returnedPayments.length > 0 && (
                    <Tag
                      icon={<RollbackOutlined />}
                      color="warning"
                      style={{ margin: 0, fontSize: 11 }}
                    >
                      {returnedPayments.length} {t("returns")}
                    </Tag>
                  )}
                </div>

                <RightOutlined style={{ fontSize: 12, color: "#bbb" }} />
              </div>
            </div>
          )}
          {!hidePayments && (
            <>
              {checkIfCashAndOnlineDisabled ? (
                <span
                  style={{
                    color: "#ff4d4f",
                    fontSize: 15,
                    fontWeight: 500,
                  }}
                >
                  {t(
                    `Cash and Online Payments are disabled. Please enable one of them from`,
                  )}{" "}
                  <Link
                    style={{
                      color: "#ff4d4f",
                      fontSize: 15,
                      fontWeight: 500,
                      textDecoration: "underline",
                    }}
                    to="/manage/Integration/Payment"
                  >
                    {t("payment settings.")}
                  </Link>
                </span>
              ) : (
                <Radio.Group
                  defaultValue="products"
                  buttonStyle="solid"
                  className="my-2  w-100"
                  value={paymentType}
                  onChange={(e) => {
                    if (e.target.value !== "custom") {
                      setOrderSettingsState({
                        paymentType: e.target.value,
                        paymentCType: "",
                        paymentReference: "",
                      });
                    }
                  }}
                >
                  {settings.enable_cash_for_pos && (
                    <Radio.Button className="posRadioButton" value={"cash"}>
                      {t("Cash")}
                    </Radio.Button>
                  )}
                  {settings.enable_online_payments_for_pos && (
                    <Radio.Button className="posRadioButton" value={"online"}>
                      {t("Online")}
                    </Radio.Button>
                  )}
                  {settings.enable_wallet &&
                    settings.enable_wallet_staff &&
                    customer?.userID &&
                    customer?.userDetails?.wallet >= orderTotalPrice && (
                      <Radio.Button className="posRadioButton" value={"wallet"}>
                        {t("Wallet")}
                        <span
                          style={{
                            position: "absolute",
                            fontSize: 10,
                            bottom: -1,
                            width: "100%",
                            right: 0,
                          }}
                        >
                          {customer?.userDetails?.wallet.toFixed(
                            settings.currency_decimals,
                          )}
                        </span>
                      </Radio.Button>
                    )}
                  {settings.enable_loyalty_points &&
                    settings.enable_loyalty_points_staff &&
                    settings.enable_loyalty_points_payment &&
                    customer?.userID &&
                    avaialblePoints >= loyaltyPointsNeeded && (
                      <Radio.Button
                        className="posRadioButton"
                        value={"loyalty points"}
                      >
                        {t("Loyalty Points")}
                        <span
                          style={{
                            position: "absolute",
                            fontSize: 10,
                            bottom: -1,
                            width: "100%",
                            right: 0,
                          }}
                        >
                          {loyaltyPointsNeeded}
                        </span>
                      </Radio.Button>
                    )}
                  {settings.enable_custom_payments_for_pos && (
                    <Radio.Button
                      className="posRadioButton"
                      value={"custom"}
                      onClick={() =>
                        this.setState({ customPaymentModallVisible: true })
                      }
                    >
                      {t("Custom")} {paymentCType && `(${paymentCType})`}
                    </Radio.Button>
                  )}
                </Radio.Group>
              )}
            </>
          )}

          {!hidePayments && (
            <Button
              color={"primary"}
              icon={<SwapOutlined style={{ fontSize: 16 }} />}
              onClick={() => this.setState({ splitPaymentModalVisible: true })}
              type="link"
            >
              {t("Split between multiple methods")}
            </Button>
          )}
        </div>

        {!isReturningPayment &&
          !hidePayments &&
          !["wallet", "loyalty points", "split"].includes(paymentType) && (
            <div className="px-2 my-4 text-center">
              <p style={{ fontSize: 15 }}>{t("Payment Completed ?")}</p>
              <Radio.Group
                defaultValue="products"
                buttonStyle="solid"
                className="my-2  w-100"
                value={paymentComplete}
                onChange={(e) => {
                  setOrderSettingsState({
                    paymentComplete: e.target.value,
                  });
                }}
              >
                <Radio.Button className="posRadioButton" value={true}>
                  {t("Yes")}
                </Radio.Button>
                <Radio.Button className="posRadioButton" value={false}>
                  {t("No")}
                </Radio.Button>
              </Radio.Group>
            </div>
          )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  config: state.config,
  permissions: state.auth.permissions,
  is_staff: state.auth.is_staff,
  settings: state.auth.settings,
  customer: state.pos.customer,
  manuallyAppliedPromotion: state.pos.manuallyAppliedPromotion,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNamespaces()(OrderPayment));
